import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import * as Yup from 'yup';
import { useFormik } from 'formik';

import { FormControl } from '../../ui/FormControl';
import { AutoComplete } from '../../ui/AutoComplete';
import { ReactComponent as Point } from '../../../assets/images/point.svg';
import { ReactComponent as Close } from '../../../assets/images/close.svg';
import { ReactComponent as FillClose } from '../../../assets/images/fillClose.svg';
import { ReactComponent as SubscribeActive } from '../../../assets/images/SubscribeActive.svg';
import { ReactComponent as Subscribe } from '../../../assets/images/Subscribe.svg';
import classes from './AddUserDialog.module.scss';
import { UserCreate } from '../../../types/user';
import {
  useRole,
  useStatus,
  useSubdivivsion,
  useUsers,
} from '../../../hooks/entityHooks';
import add from '../../../assets/images/add.png';
import { SUBDIVISION_HEAD_ID } from '../../../types/utils/constants';
import { Multiselect } from '../../ui/Multiselect';
import { Subdivision } from '../../../types/subdivision';

type FormikValues = {
  email: string;
  surname: string;
  name: string;
  password: string;
  repeatePassword: string;
  roleName: any;
  subdivisions: Array<Subdivision>;
};
type Role = {
  id: number;
  name: string;
};

type Props = {
  handleGetList(): void;
};
export const AddUserDialog = ({ handleGetList }: Props) => {
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [subscribe, setSubscribe] = useState(false);
  // const [match, setMatch] = useState(true);
  const { createEntity, getEntityList } = useUsers();
  const { entityList: roles, getEntityList: getRoles } = useRole();
  const { getAllSubdivisions } = useSubdivivsion();
  const [subdivisions, setSubdivisions] = useState<Subdivision[]>([]);
  const [areSubdivisionsDisabled, setAreSubdivisionsDisabled] = useState(true);

  useEffect(() => {
    getRoles();
    getAllSubdivisions().then((res) => setSubdivisions(res));
  }, []);

  const useStyles = makeStyles({
    root: {
      background: '#FF7221 !important',
      borderRadius: 0,
      color: 'white',
      fontWeight: 550,
      '&:hover, &:focus': {
        background: '#DE6109',
      },
      fontFamily: 'HelveticaNeueCyr',
      // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      height: 50,
      padding: '0 30px',
    },

    button: {
      background: 'none',
      borderRadius: 0,
      // width: '100%',
      color: '#444A52 !important',
      textTransform: 'none',
      fontWeight: 550,
      '&:hover, &:focus': {
        background: 'none',
      },
      fontFamily: 'HelveticaNeueCyr',
      // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      height: 24,
      padding: 0,
      border: 'none',
      boxShadow: 'none',
      textAlign: 'center',
    },
    image: {
      marginRight: 8,
    },
  });
  const {
    handleSubmit,
    handleBlur,
    values,
    errors,
    touched,
    setFieldValue,
  } = useFormik<FormikValues>({
    initialValues: {
      email: '',
      name: '',
      password: '',
      repeatePassword: '',
      roleName: '',
      surname: '',
      subdivisions: [],
    },
    onSubmit: () => {
      if (values.password === values.repeatePassword) {
        const user: UserCreate = {
          surname: values.surname,
          role: values.roleName.id,
          password: values.password,
          name: values.name,
          email: values.email,
          subscription: subscribe,
          subdivisions: values.subdivisions,
        };
        const response = createEntity(user);
        response.then(() => {
          handleGetList();
          setOpen(false);
        });
      } else {
        // setMatch(false);
      }
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .email('Это не email')
        .required('Обязательно для заполнения'),
      name: Yup.string().required('Обязательно для заполнения'),
      password: Yup.string()
        .min(8, 'Пароль должен быть длиннее 8 символов')
        .required('Обязательно для заполнения'),
      repeatePassword: Yup.string()
        .oneOf([Yup.ref('password'), ''], 'Пароли не совпадают')
        .required('Обязательно для заполнения'),
      surname: Yup.string().required('Обязательно для заполнения'),
    }),
  });

  const style = useStyles();
  const [focus, setFocus] = useState(false);

  const onRoleChange = (value: Role | any) => {
    setAreSubdivisionsDisabled(value.id !== SUBDIVISION_HEAD_ID);
    setFieldValue('roleName', value);
  };

  return (
    <div>
      <Button
        variant="outlined"
        onClick={handleClickOpen}
        className={style.button}
      >
        <img src={add} alt="" className={style.image} />
        Добавить пользователя
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="sm"
      >
        <form className={classes.form} onSubmit={handleSubmit}>
          <DialogTitle>
            <div className={classes.form__dialogTitle}>
              <span>Добавление пользователя</span>
              <div
                className={classes.close}
                onMouseOver={(e) => setFocus(true)}
                onMouseOut={(e) => setFocus(false)}
                onClick={(e) => setOpen(false)}
              >
                {focus ? <FillClose /> : <Close />}
              </div>
            </div>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <div>
              <div className={classes.title}>
                <p>Email</p>
                <Point className={classes.title__point} />
              </div>

              <div>
                <FormControl
                  placeholder="Email"
                  type="text"
                  name="email"
                  value={values.email}
                  onChange={(e) => setFieldValue('email', e.target.value)}
                  error={Boolean(errors?.email && touched?.email)}
                  errorMessage={errors?.email}
                  onBlur={handleBlur}
                  // onFocus={setFieldTouched('email', false)}
                />
              </div>
            </div>

            <div>
              <div className={classes.title}>
                <p>Фамилия</p>
                <Point className={classes.title__point} />
              </div>

              <div>
                <FormControl
                  placeholder="Фамилия"
                  type="text"
                  name="surname"
                  value={values.surname}
                  onChange={(e) => setFieldValue('surname', e.target.value)}
                  error={Boolean(errors?.surname && touched?.surname)}
                  errorMessage={errors?.surname}
                  onBlur={handleBlur}
                />
              </div>
            </div>

            <div>
              <div className={classes.title}>
                <p>Имя</p>
                <Point className={classes.title__point} />
              </div>

              <div>
                <FormControl
                  placeholder="Имя"
                  type="text"
                  name="name"
                  value={values.name}
                  onChange={(e) => setFieldValue('name', e.target.value)}
                  error={Boolean(errors?.name && touched?.name)}
                  errorMessage={errors?.name}
                  onBlur={handleBlur}
                />
              </div>
            </div>

            <div>
              <div className={classes.title}>
                <p>Пароль</p>
                <Point className={classes.title__point} />
              </div>

              <div className={classes.form__password}>
                <FormControl
                  placeholder="Пароль"
                  type="password"
                  name="password"
                  value={values.password}
                  onChange={(e) => {
                    setFieldValue('password', e.target.value);
                    // setMatch(true);
                  }}
                  error={Boolean(errors?.password && touched?.password)}
                  errorMessage={errors?.password}
                  onBlur={handleBlur}
                />
                {/* {!(errors?.password && touched?.password) && !match ? ( */}
                {/*  <p className={classes.form__password__p}> */}
                {/*    Пароли не сопадают */}
                {/*  </p> */}
                {/* ) : null} */}
              </div>
            </div>

            <div>
              <div className={classes.title}>
                <p>Повторите пароль</p>
                <Point className={classes.title__point} />
              </div>

              <div className={classes.form__password}>
                <FormControl
                  placeholder="Повторите пароль"
                  type="password"
                  name="repeatePassword"
                  value={values.repeatePassword}
                  onChange={(e) => {
                    setFieldValue('repeatePassword', e.target.value);
                    // setMatch(true);
                  }}
                  error={Boolean(
                    errors?.repeatePassword && touched?.repeatePassword,
                  )}
                  errorMessage={errors?.repeatePassword}
                  onBlur={handleBlur}
                />
                {/* {!(errors?.repeatePassword && touched?.repeatePassword) && */}
                {/*! match ? ( */}
                {/*  <p className={classes.form__password__p}> */}
                {/*    Пароли не сопадают */}
                {/*  </p> */}
                {/* ) : null} */}
              </div>
            </div>
            <div>
              <div className={classes.title}>
                <p>Роль</p>
                <Point className={classes.title__point} />
              </div>

              <div className={classes.form__autoSelect}>
                <AutoComplete
                  options={roles}
                  getOptionLabel={(option) =>
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    option.name ? option.name : 'Роль'
                  }
                  value={values.roleName}
                  onChange={(event, value) => onRoleChange(value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Роль"
                      variant="outlined"
                      name="roleName"
                      error={Boolean(errors?.roleName && touched?.roleName)}
                    />
                  )}
                />
                {errors?.roleName && touched?.roleName ? (
                  <p className={classes.form__autoSelect__p}>
                    {errors?.roleName}
                  </p>
                ) : null}
              </div>

              <div>
                <div className={classes.title}>
                  <p>Подразделение</p>
                  <Point className={classes.title__point} />
                </div>

                <Multiselect
                  subdivisions={subdivisions}
                  disabled={areSubdivisionsDisabled}
                  onSelect={(value) => setFieldValue('subdivisions', value)}
                />
              </div>

              <div className={classes.form__suscribe}>
                <div onClick={(e) => setSubscribe(!subscribe)}>
                  {subscribe ? (
                    <SubscribeActive className={classes.form__suscribe__logo} />
                  ) : (
                    <Subscribe className={classes.form__suscribe__logo} />
                  )}
                </div>
                <div>Подписка</div>
              </div>
            </div>
          </DialogContent>
          <div className={classes.form__row__button}>
            <Button
              className={style.root}
              // onClick={handleClose}
              type="submit"
              color="primary"
            >
              Добавить пользователя
            </Button>
          </div>
        </form>
      </Dialog>
    </div>
  );
};
